import SimpleModalContent from "./SimpleModalContent";
import React from "react";
import {File} from "../../shared/Types";
import {useCsContext} from "../../state/CsInstance";
import {observer} from "mobx-react-lite";
import ValidationForm from "../ValidationForm/ValidationForm";
import styles from "./SimpleModalContent.module.scss";

interface ChangeFilenameModalType {
	fileData: File;
}

/**
 * Modal displayed when changing a file's name:
 * ┌─────────────────────────────────────────┐
 * │  Renaming <file>                        │
 * │  Remember it doesn't change your code.  │
 * │  ┌──────────────────────────────────┐   │
 * │  └──────────────────────────────────┘   │
 * │  <name> is an invalid class name        │
 * │  ┌─────────────┐      ┌─────────────┐   │
 * │  │    Cancel   │      │   Confirm   │   │
 * │  └─────────────┘      └─────────────┘   │
 * └─────────────────────────────────────────┘
 */
const ChangeFilenameModalContent = (props: ChangeFilenameModalType) => {
	const {codeStore, globalModalStore} = useCsContext();

	const oldName = props.fileData.name;

	const onClickSuccess = () => {
		if (!isValid) {
			// Shouldn't happen, but just in case
			globalModalStore.closeModal();
			return;
		}
		codeStore.renameActorClass(oldName, newClass);
		codeStore.hasUncompiledChanges = true;
		globalModalStore.closeModal();
	};

	const onClickCancel = () => {
		globalModalStore.closeModal();
	};

	const [newClass, setNewClass] = React.useState("");
	const [isValid, setIsValid] = React.useState(false);

	return (
		<SimpleModalContent
			onSuccess={onClickSuccess}
			onCancel={onClickCancel}
			disableSubmit={!isValid}
			title={"Renaming " + props.fileData.name}
		>
			<div className={styles.modalText}>
				Remember, this does not change your code.
			</div>
			<ValidationForm
				setNewClass={setNewClass}
				setValidationResult={setIsValid}
			/>
		</SimpleModalContent>
	);
};

export default observer(ChangeFilenameModalContent);
